import AutocompleteWithQuery from "components/AutocompleteWithQuery";
import useGlobalContext from "hooks/globalData";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import { ListRequestOfBaseFilter } from "services/KnowfullyAdminClient";

type AttendanceRecordStatusSelectorProps = {
  onChange: (selected: string | undefined) => void;
};

const AttendanceRecordStatusSelector = ({
  onChange,
}: AttendanceRecordStatusSelectorProps) => {
  const [value, setValue] = useState<string>();
  const { formatMessage: t } = useIntl();

  const { attendanceRecordService } = useGlobalContext();

  const fetchedStatuses = useQuery("attendanceRecordStatus", () =>
    attendanceRecordService.getAttendanceRecordStatus(
      ListRequestOfBaseFilter.fromJS({
        pageSize: -1,
        sortField: "name",
      })
    )
  );

  const onChangeInternal = (value: string | undefined) => {
    setValue(value);
    onChange(value);
  };

  return (
    <AutocompleteWithQuery
      value={value}
      onChange={onChangeInternal}
      labelField="name"
      fetchedData={fetchedStatuses}
      failMessage={t({ id: "fetchError" })}
      textFieldProps={{ variant: "outlined" }}
      label={t({ id: "resultsType" })}
    />
  );
};

export default AttendanceRecordStatusSelector;
